// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"d323bb95f3484ba5fef5","655":"c150fdbea848574f4960"}[chunkId] + ".js";
};